import React from "react";
import {OrbitComponent} from "../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {CyClass} from "../../../../../../../common/cy-classes";
import {SwedenSelfTestButtonBox} from "./boxes/sweden.self-test-button.box";
import {SwedenResponsibleGamingButtonSBGIconClassName} from "../boxes/sweden.responsible-gaming-button-base.box";

interface SwedenSelfTestButtonComponentProps {
    useIconsOnly: boolean;
    isShownInHeader: boolean;
}
export const SwedenSelfTestButtonComponent = observer(
    class SwedenSelfTestButtonComponent extends OrbitComponent<SwedenSelfTestButtonComponentProps> {
        private _onClickHandler = async () => {
            this.services.analytics.sendOrbitUserFlowEvent("Navigation","Header", 'Icon_self_test_click');
            this.services.analytics.sendElasticInfoEvent({
                eventType: 'sweden_self_test',
                category: 'Navigation',
                action: 'Header',
                label: 'Icon_self_test_click'
            },true);

            await this.services.linksNavigation.openSelfTest();
        }

        render() {
            const SelfTestIcon = this.services.theme.currentTheme.icons.selfTestRegulationIcon;
            const SelfTestSymbolIcon = this.services.theme.currentTheme.icons.selfTestRegulationSymbolIcon;

            return (
                <SwedenSelfTestButtonBox className={CyClass('cy-sweden-self-test-button')} useIconsOnly={this.props.useIconsOnly} isShownInHeader={this.props.isShownInHeader} onClick={this._onClickHandler}>
                    {this.props.useIconsOnly ?  <SelfTestSymbolIcon size={2.5} className={CyClass('cy-sweden-self-test-icon')}/>
                        : <SelfTestIcon className={CyClass('cy-sweden-self-test-icon') + " " + SwedenResponsibleGamingButtonSBGIconClassName}
                        />}
                </SwedenSelfTestButtonBox>)

        }
    }
);